import 'css-chunk:src/app/containers/Home/ApplicationsView/ApplicationDetailView.scss';export default {
  "ApplicationDetailView": "_ApplicationDetailView_239m9_2",
  "header": "_header_239m9_2",
  "action": "_action_239m9_7",
  "children": "_children_239m9_10",
  "menu": "_menu_239m9_10",
  "warning": "_warning_239m9_14"
};